import axios from 'axios'

interface ILog {
  message: any
}

export const sendLogs = async (logs: ILog) => {
  // if local development, don't send logs
  if (process.env.NODE_ENV === 'development') return

  const response = await axios.post(`/log-client-errors`, logs)
  return response.data
}
